import { HiOutlineUserGroup } from "react-icons/hi"

const Group = (props: any) => {
  return <HiOutlineUserGroup strokeWidth={1} {...props} />
}

export default Group
